import { useServices } from '@/components/ServiceContext.tsx';
import React from 'react';
import GenericReportPage from '@/pages/Reports/GenericReportPage.tsx';
import { reportDefinitions } from '@lambda-layer/constants/reportDefinitions';

const CountsByGradeReport: React.FC = () => {
  const { boughtListService } = useServices();

  const report = reportDefinitions.find(
    rd => rd.id === 'report-bl-counts-by-grade'
  );

  return (
    report && (
      <GenericReportPage
        listType="boughtlist"
        listService={boughtListService}
        filterDefinitions={report.filterDefinitions}
        exportReportName={report.exportName}
      />
    )
  );
};

export default CountsByGradeReport;
